import React, { useEffect, useState } from 'react'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import { Box, Stack, Typography } from '@mui/material'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import moment from 'moment'
import API from '../../../../../services/API'
import { useNavigate } from 'react-router-dom'
import { Cancel, CheckCircle } from '@mui/icons-material'

const CentreBox = (props) => (
  <Box
    height="100%"
    width="100%"
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    {props.children}
  </Box>
)

const Events = () => {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    API.get('/client-portal/events')
      .then((res) => {
        if (res.status === 200) {
          setEvents(res.data)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  const activeEvents = events.filter(
    (x) =>
      moment(x.startDate).isAfter(moment()) &&
      moment(x.endDate).isBefore(moment())
  )
  const pastEvents = events.filter((x) => moment(x.endDate).isAfter(moment()))
  const upcomingEvents = events.filter((x) =>
    moment(x.startDate).isAfter(moment)
  )

  return (
    <CustomDataGrid
      rows={events}
      color="anGreen"
      loading={loading}
      columns={[
        {
          field: 'startDate',
          renderCell: ({ row }) => moment(row.startDate).format('DD MMM YYYY'),
          headerName: 'Date',
          minWidth: 160,
        },
        { field: 'title', headerName: 'Event Title', minWidth: 200, flex: 1 },
        { field: 'status', minWidth: 140, headerName: 'Status', flex: 1 },
        {
          field: 'feedback',
          headerName: 'Feedback',
          minWidth: 120,
          renderCell: ({ row }) =>
            moment(row.startDate).isAfter(moment()) ? (
              ''
            ) : row?.postEventAnalysis?.clientFeedback ? (
              <CheckCircle color="success" />
            ) : (
              <Cancel color="anPurple" />
            ),
        },
      ]}
      getRowId={(row) => row._id}
      slots={{ toolbar: () => null }}
      disableRowSelectionOnClick
      onRowClick={({ row }) => navigate('/events/' + row._id)}
    />
  )
}

export default Events
